import { Component, EventEmitter, HostListener, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { TooltipService } from '@shared/services/tooltip.service';
import { Tooltip } from 'primeng/tooltip';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent {
  @Input() tooltipMessage!: string | TemplateRef<any>;
  @Input() addClass: string = '';
  @Input() isDefaultPaymentMethodAdded: boolean = true;
  @Input() isWhite: boolean;
  @Input() tooltipContext: any;
  @ViewChild(Tooltip) tooltip!: Tooltip;
  @Output() parkingDetailsObj = new EventEmitter<any>();
  isSmallScreen: boolean = false;
  isTooltipVisible: boolean = false;
  tooltipPosition: string = 'top'; // Default position
  constructor(private readonly tooltipService: TooltipService) {  // Inject the service
    this.checkScreenSize();
  }
  get tooltipMessageString(): string {
    return typeof this.tooltipMessage === 'string' ? this.tooltipMessage : '';
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkScreenSize();
  }

  checkScreenSize(): void {
    this.isSmallScreen = window.innerWidth < 1200;
    this.tooltipPosition = this.isSmallScreen ? 'left' : 'top'; // Update position based on screen size
    this.sendParkingDetails();
    if (!this.isSmallScreen && this.isTooltipVisible) {
      this.tooltipService.deactivateTooltip(this.tooltip);  // Deactivate using the service
      this.isTooltipVisible = false;
    }
  }

  sendParkingDetails() {
    const data = { isSmallScreen: this.isSmallScreen };
    this.parkingDetailsObj.emit(data);
  }

  onClick(_event: Event): void {
    if (this.isSmallScreen) {
      if (!this.isTooltipVisible) {
        this.tooltipService.activateTooltip(this.tooltip);  // Activate using the service
        this.isTooltipVisible = true;
      } else {
        this.tooltipService.deactivateTooltip(this.tooltip);  // Deactivate using the service
        this.isTooltipVisible = false;
      }
    }
  }

  onMouseEnter(): void {
    if (!this.isSmallScreen) {
      this.tooltipService.activateTooltip(this.tooltip);  // Activate using the service
      this.isTooltipVisible = true;
    }
  }

  onMouseLeave(): void {
    if (!this.isSmallScreen) {
      this.tooltipService.deactivateTooltip(this.tooltip);  // Deactivate using the service
      this.isTooltipVisible = false;
    }
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event): void {
    const clickedElement = event.target as HTMLElement;
    if (this.isTooltipVisible && !clickedElement.closest('.custom-info-icon') && !clickedElement.closest('.custom-redinfo-icon')) {
      this.tooltipService.deactivateTooltip(this.tooltip);  // Deactivate using the service
      this.isTooltipVisible = false;
    }
  }
  get tooltipTemplate(): TemplateRef<any> | null {
  return this.tooltipMessage instanceof TemplateRef ? this.tooltipMessage : null;
}
}
